// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__txka7","summary":"CartItem_summary__AwGKZ","price":"CartItem_price__qziVP","amount":"CartItem_amount__cBJpf","actions":"CartItem_actions__aTGe2"};